var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPermit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7417_5827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3787 4.67109V14.0641H0.574219V0.573242H8.13753L12.3787 4.67109Z",
    stroke: "#2F3139",
    strokeWidth: 1.14672,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10156 9.84814H9.00381",
    stroke: "#2F3139",
    strokeWidth: 1.07084,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9191 12.7995C11.5852 12.0744 11.2142 10.7843 11.0287 10.27L10.8853 10.0002C10.7589 9.7472 10.6914 9.45209 10.6914 9.14854C10.6914 8.13673 11.4503 7.31885 12.3778 7.31885C13.3053 7.31885 14.0641 8.13673 14.0641 9.14854C14.0641 9.47738 13.9882 9.78093 13.8449 10.0507L13.7521 10.2784C13.5582 10.7927 13.1619 12.0912 13.828 12.8079",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9191 12.7995C11.5852 12.0744 11.2142 10.7843 11.0287 10.27L10.8853 10.0002C10.7589 9.7472 10.6914 9.45209 10.6914 9.14854C10.6914 8.13673 11.4503 7.31885 12.3778 7.31885C13.3053 7.31885 14.0641 8.13673 14.0641 9.14854C14.0641 9.47738 13.9882 9.78093 13.8449 10.0507L13.7521 10.2784C13.5582 10.7927 13.1619 12.0912 13.828 12.8079",
    stroke: "#2F3139",
    strokeWidth: 1.18045,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5309 13.0103H9.20703V15.5398H15.5309V13.0103Z",
    fill: "white",
    stroke: "#2F3139",
    strokeWidth: 1.18045,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10156 6.47559H9.00381",
    stroke: "#2F3139",
    strokeWidth: 1.07084,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7417_5827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.1216,
    height: 16.13,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermit);
export default __webpack_public_path__ + "static/media/permit.6e1d52a443ccbcb4e246a55d0c72fe11.svg";
export { ForwardRef as ReactComponent };